import { emptyGuid } from 'constants/emptyGuid';
import { AllergenLogic } from 'enums/allergenLogic';
import { AllergenLight } from 'types/Allergen/AllergenLight';
import { mapCarbonDioxide } from 'types/Co2Footprint/SaveCo2Footprint';
import { Ingredient } from 'types/Ingredient/Ingredient';
import { SaveIngredientDto } from 'types/Ingredient/SaveIngredientDto';
import * as NutrientValueList from 'types/NutrientValue/NutrientValueList';
import { SaveNutrientValue } from 'types/NutrientValue/SaveNutrientValue';
import { SeasonMappingDto } from 'types/Season/SeasonMappingDto';
import { TagLight } from 'types/Tag/TagLight';
import { SaveUnitWeight } from 'types/UnitWeight/SaveUnitWeight';
import * as UnitWeightList from 'types/UnitWeight/UnitWeightList';

type SaveAllergen = {
	[key: string]: AllergenLogic;
};

export function mapToSaveIngredientDto(
	ingredient: Ingredient,
	currencyCode: string
): SaveIngredientDto {
	return {
		isScalingFactorOverridden: ingredient.isScalingFactorOverridden,
		scalingFactor: ingredient.scalingFactor,
		density: ingredient.density,
		calories: ingredient.calories,
		characteristic: ingredient.characteristic,
		currencyCode: currencyCode,
		imageId: ingredient.image?.id ?? null,
		price: ingredient.price,
		products: ingredient.products.map((p) => p.id),
		baseIngredientId: ingredient.baseIngredient.id ?? emptyGuid,
		namePluralTranslations: ingredient.namePluralTranslations,
		nameSingularTranslations: ingredient.nameSingularTranslations,
		nutrientValues: mapNutrientValues(ingredient.nutrientValues),
		categories: ingredient.categories.map((c) => c.id),
		allergens: mapAllergens(ingredient.allergens),
		isAllergenOverridden: ingredient.isAllergenOverridden,
		seasons: ingredient.seasons.map((season: SeasonMappingDto) => season.id),
		isSeasonOverridden: ingredient.isSeasonOverridden,
		tags: ingredient.tags.map((tag: TagLight) => tag.id),
		isTagOverridden: ingredient.isTagOverridden,
		unitWeights: mapUnitWeights(ingredient.unitWeights),
		isUnitWeightOverridden: ingredient.isUnitWeightOverridden,
		hasNutriScore: ingredient.hasNutriScore,
		nutriScoreCategory: ingredient.nutriScoreCategoryIsSetByUser
			? ingredient.nutriScoreCategory
			: null,
		nutriScoreCategoryIsSetByUser: ingredient.nutriScoreCategoryIsSetByUser,
		isCarbonDioxideOverridden: ingredient.isCarbonDioxideOverridden,
		carbonDioxide: mapCarbonDioxide(ingredient.carbonDioxide),
		synonyms: ingredient.synonyms,
	};
}

function mapNutrientValues(nutrientValues: NutrientValueList.Type): SaveNutrientValue {
	const result: SaveNutrientValue = {};
	for (const nutrientValue of nutrientValues) {
		result[nutrientValue.id] = nutrientValue.value;
	}
	return result;
}

function mapAllergens(allergens: AllergenLight[]): SaveAllergen {
	var map = {} as SaveAllergen;

	allergens.map((a) => {
		map[a.id] = a.logic;
	});

	return map;
}

function mapUnitWeights(unitWeights: UnitWeightList.Type): SaveUnitWeight<number> {
	var map = {} as SaveUnitWeight<number>;

	unitWeights.forEach((u) => {
		map[u.id] = u.weight;
	});

	return map;
}
